var _g, _path, _path2, _circle, _circle2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_518_2898)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.1774,
    cy: 19.9008,
    rx: 19.3552,
    ry: 19.3548,
    fill: "url(#paint0_radial_518_2898)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6153 25.4215C16.993 27.1533 17.9536 28.7031 19.3365 29.8119C20.7194 30.9207 22.4409 31.5214 24.2135 31.5136C25.986 31.5059 27.7022 30.8901 29.0753 29.7693C30.4485 28.6484 31.3954 27.0903 31.758 25.3552L30.4069 25.0729C30.109 26.4986 29.3308 27.779 28.2025 28.7C27.0742 29.621 25.6639 30.127 24.2074 30.1334C22.7509 30.1398 21.3363 29.6462 20.1999 28.7351C19.0636 27.8239 18.2743 26.5505 17.9639 25.1274L16.6153 25.4215Z",
    fill: "#39383D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4375 24.4172H31.9216L31.6944 25.7075H16.6769L16.4375 25.0623V24.4172Z",
    fill: "#39383D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.0943,
    r: 2,
    fill: "#39383D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.2109,
    cy: 16.0943,
    r: 2,
    fill: "#39383D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_518_2898",
    x: 0.822266,
    y: 0.546021,
    width: 46.7109,
    height: 46.7095,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_518_2898"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_518_2898",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_518_2898",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.9838 10.9976) rotate(77.6373) scale(28.9288 28.9293)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1E3AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98ED3A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/Happy.81f39fae3091f8efa871607c4434ad68.svg";
export { ForwardRef as ReactComponent };